import { strokeIconCss, BaseIconProps } from "@components/Icon";
import styled from "@emotion/styled";

import { ReactComponent as HeartIconSvg } from "src/assets/icons/heart.svg";

export default styled(HeartIconSvg)<BaseIconProps>`
  ${(props) => strokeIconCss(props)}
`;
